import api from '@/api';

export async function fetchCompanyInfo(companyId) {
    try {
        const res = await api.get(`/admin/${companyId}`);
        return {
            company: res.data,
            error: null
        }
    }              
    catch (err) {
        console.error("Error fetching company information:", err);
        return {
        company: null,
        error: "Error fetching company information.",
        };
    }
}

export  async function getUserCompany() {
    try {
        const res = await api.get('/users/company');
        return {
            company: res.data.company,
            error: null
        }
    } catch (err) {
        console.error(err)
        return {
            company: null,
            error: 'Error fetching company information.'
        }
    }
}

export async function updateCompanyInfo(companyId ,newCompanyData) {
    try {
        const res = await api.patch(`/admin/${companyId}`, newCompanyData);
        return {
            company: res.data,
            error: null
        }
    } catch (err) {
        console.error(err)
        return {
        company: null,
        error: 'Error updating company information.'
        }
    }
}

export async function updatePassword(newPassword){
    try{
        const res = await api.patch(`/users/`, { password: newPassword });
        return {
            res: res.data.success,
            error: null,
        }
    }catch(err){
        console.error("Error en updatePassword:", err);
        return {
            res: null,
            error: err,
    }
}
}